import React from "react";
import { cn } from "./cn";

export default function Table({ className, children, ...rest }) {
  return (
    <div className={cn("w-full overflow-auto rounded-2xl border border-arena/12 bg-white", className)}>
      <table className="w-full border-collapse text-sm" {...rest}>
        {children}
      </table>
    </div>
  );
}
